module.exports = __webpack_public_path__ + "img/grabfood.867751d6.png";